import axios from "axios"
import { error, getdata, loaddata } from "./actiontype"


const deta=(params)=>(dispatch)=>{
 dispatch({type:loaddata})
 return axios.get('https://tripoto-data-1czc.onrender.com/products',params)
 .then((res)=>{
    dispatch({type:getdata,payload:res.data})

 }).catch((err)=>{
    dispatch({type:error})
    console.log(err)
 })
}

export {deta}